/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from 'vue-property-decorator'
import {formatDate} from '@/utils/timeFilter'
import {
    getDownloadFinanceContractById,
    setFinanceInvoiceStatus
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import {Loading} from "element-ui";
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({})
export default class Contract extends Vue {
    logShow = true
    contractId = NaN
    contractInfo = null
    status: number = null
    isUpdatedData = '0'
    activities = []
    // get elImageUrls() {
    //     console.log(this.contractInfo)
    //     if(this.contractInfo.financeRefundProofList && this.contractInfo.financeRefundProofList.length > 0){
    //         return this.contractInfo.financeRefundProofList.map(item => item.url)
    //     }
    // }
    fileTypeslist: any = [
        {name: '学生合同', val: '0'},
        {name: '代理合同', val: '1'},
        {name: '高校合同', val: '2'}
    ]
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    financeRepeatOrderUser = {}
    cancleReview = false
    reviewDialog = false
    disBtn = false
    opinion = '' // 审批意见
    withdraw_id: number = null
    downloadUrl = ''
    deparment = ''
    contractCode = ''
    isShow = ''
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    previewName= ''
    previewVisible = false
    previewPath = ''
    openContrDialog = false
    fileList = []
    editFileList = []
    isRequired = false
    editFiles = {
        downloadUrl: null
    }
    type = ''
    fileId = ''
    contractLoading = false
    contractTypes = ''
    loading = false
    isNotReject = false
    uploadData = {
        bucket: 'crm',
        signature: ''
    }

    menuBtn = menuBtn

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        this.approval_id = Number(this.$route.query.approval_id)
        this.types = this.$route.query.types as string
        this.type = this.$route.query.type as string
        this.getMessageReviewById()
        this.approval_type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string
        this.contractTypes = this.$route.query.financeContractTypes as string
    }

    formatDate = formatDate

    // 上传签署合同
    openDialogOfContract() {
         this.openContrDialog = true
    }
    // 取消关闭
    handleCloseContr() {
        this.openContrDialog = false
    }
    // 确定
    handleConfirmContr() {
        this.downloadUrl = this.editFiles.downloadUrl
        this.openContrDialog = false
    }

    beforeUpload(file) {
        this.contractLoading = true;//上传时显示
        this.$message("正在上传中，请稍后")
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    uploadSuccess(response, file, fileList) {
        // const {data} = res
        // this.editFiles.downloadUrl = data.ossUrl
        // this.$message.success('上传成功')
        // this.contractLoading = false
        if (fileList.every(item => item.status == 'success')) {
            this.fileList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.editFiles.downloadUrl =  this.fileList[0].url //限制只能上传一个文件
            this.$message.success('上传成功');
            this.contractLoading = false
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }

    handlePreview(file) {

        if (file.response) {
            this.previewPath = file.response.data.url
        } else {
            this.previewPath = file.url
        }
        this.previewName = file.name
        this.previewVisible = true
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    changeFile(file, fileList) {
        if (fileList.length > 1) {
            fileList.splice(0, 1);
        }
        this.fileList = fileList;
    }

    async getMessageReviewById() {
        this.loading = true
        await getMessageReviewById(this.approval_id, this.types).then((data: any) => {
            this.contractInfo = data.result
            this.contractId = data.result.id
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.contractInfo.contractAt = this.contractInfo.contractAt.replace(/&/g, ",");
            this.downloadUrl = this.contractInfo.downloadUrl
            this.contractCode = this.contractInfo.code
            this.isShow = this.contractInfo.isShow
            this.stepNode.isFirstNode = this.contractInfo.isFirstNode
            // this.stepNode.isSyncEkuaibao = this.contractInfo.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = this.contractInfo.isSyncEqianbao // 是否可以同步E签宝
            this.editFileList = this.contractInfo.editFileList
            this.editFiles.downloadUrl = this.contractInfo.downloadUrl
            if (this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }



    openReviewDialog(status: number) {
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'approveId', this.approval_id)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        // this.$set(this.approvedData, 'isSync', true)
        this.approvedVisible = true
    }
    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    // 驳回
    // reviewDialogConfirm() {
    //     const obj = {
    //         messageReviewId: this.approval_id,
    //         status: this.status,
    //         opinion: this.opinion,
    //         form: {},
    //         nodeType: this.nodeType,
    //         isSync: this.isSync,
    //     }
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
    //         this.reviewDialog = false
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch(err => {
    //         this.disBtn = false
    //     })
    // }

    // 通过
    // approvedConfirm() {
    //     const newObj = this.editFiles
    //     for(const key in newObj) {
    //         if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
    //     }
    //     // newObj.financeRefundProofList = this.fileList
    //     if(this.isRequired) {
    //         let bol = false
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 bol = true
    //                 break;
    //             }
    //         }
    //         if(bol && this.status === 1) {
    //             this.$message.error('请将编辑的信息填写完整')
    //             return
    //         }
    //     }
    //
    //     const obj = {
    //         messageReviewId: this.approval_id,
    //         status: this.status,
    //         opinion: this.opinion,
    //         form: this.status === 1 ? newObj : {},
    //         isRevoke:this.isAgreeRevoke
    //     }
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批通过中，请稍后`
    //     })
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(`审批通过`)
    //         this.reviewDialog = false
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch(err => {
    //         this.disBtn = false
    //     })
    // }


    // 撤回审批cancleReview
    async cancleReviewDialogConfirm() {
        await setFinanceInvoiceStatus({ id: this.withdraw_id, action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }

    // 预览
    previewContract() {
        window.open(this.downloadUrl, 'blank')
    }

    previewContractUrl() {
        window.open(this.contractInfo.url, 'blank')
    }

    // 查询签署结果
    queryResult() {
        getDownloadFinanceContractById({
            id: this.contractId
        })
    }



    // 驳回审批
    clickRejectButton(status: number) {
        this.$set( this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.approval_id)
        this.$set(this.stepNode, 'isSync', true)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.opinion = data.reviewIdea
        // this.isSync = data.isTouchEQ
        // this.approvalVisible = false
        // this.reviewDialogConfirm()
        this.approvalVisible = false
    }


    /*
* 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.opinion = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()
        this.approvedVisible = false
    }
}
